import React, { useState } from 'react';

export default function CredentialForm({ fields, onSave, saving, accentColor }) {
  const [values, setValues] = useState({});
  const [showPassword, setShowPassword] = useState({});
  const [errors, setErrors] = useState({});

  function set(key, value) {
    setValues((v) => ({ ...v, [key]: value }));
    setErrors((e) => ({ ...e, [key]: undefined }));
  }

  function validate() {
    const errs = {};
    fields.forEach((f) => {
      if (f.required && !values[f.key]?.trim()) {
        errs[f.key] = `${f.label} é obrigatório`;
      }
    });
    return errs;
  }

  function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    onSave(values);
  }

  const accent = accentColor || '#1e40af';

  return (
    <div style={S.wrap}>
      <div style={S.infoBox}>
        <span style={S.infoIcon}>ℹ️</span>
        <p style={S.infoText}>
          Suas credenciais serão usadas no lugar das chaves padrão do sistema ao fazer cotações
          com esta transportadora. Os valores de campos de senha são armazenados de forma segura.
        </p>
      </div>

      <form onSubmit={handleSubmit} noValidate style={S.form}>
        {fields.map((field) => {
          const isPassword = field.type === 'password';
          const revealed = showPassword[field.key];
          const hasError = !!errors[field.key];

          return (
            <div key={field.key} style={S.field}>
              <div style={S.labelRow}>
                <label style={S.label}>
                  {field.label}
                  {field.required && <span style={S.required}> *</span>}
                </label>
                {isPassword && values[field.key] && (
                  <button
                    type="button"
                    style={S.toggleVisibility}
                    onClick={() => setShowPassword((p) => ({ ...p, [field.key]: !p[field.key] }))}
                  >
                    {revealed ? 'Ocultar' : 'Mostrar'}
                  </button>
                )}
              </div>

              <input
                type={isPassword && !revealed ? 'password' : 'text'}
                value={values[field.key] || ''}
                onChange={(e) => set(field.key, e.target.value)}
                placeholder={field.placeholder || ''}
                style={{ ...S.input, ...(hasError ? S.inputError : {}) }}
                autoComplete={isPassword ? 'new-password' : 'off'}
              />

              {field.helpText && !hasError && (
                <span style={S.helpText}>{field.helpText}</span>
              )}
              {hasError && (
                <span style={S.errorText}>{errors[field.key]}</span>
              )}
            </div>
          );
        })}

        <div style={S.footer}>
          <div style={S.footerInfo}>
            <span style={S.lockIcon}>🔒</span>
            <span style={S.footerText}>Credenciais não são exibidas após salvas por segurança</span>
          </div>
          <button
            type="submit"
            disabled={saving}
            style={{ ...S.btnSave, background: accent }}
          >
            {saving ? 'Salvando...' : '💾 Salvar credenciais'}
          </button>
        </div>
      </form>
    </div>
  );
}

const S = {
  wrap: {},
  infoBox: {
    display: 'flex', gap: '10px', alignItems: 'flex-start',
    background: '#eff6ff', border: '1px solid #bfdbfe',
    borderRadius: '8px', padding: '12px 14px', marginBottom: '20px',
  },
  infoIcon: { fontSize: '16px', flexShrink: 0, marginTop: '1px' },
  infoText: { fontSize: '13px', color: '#1e40af', lineHeight: 1.5, margin: 0 },
  form: { display: 'flex', flexDirection: 'column', gap: '18px' },
  field: { display: 'flex', flexDirection: 'column', gap: '5px' },
  labelRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  label: { fontSize: '13px', fontWeight: '600', color: '#374151' },
  required: { color: '#dc2626' },
  toggleVisibility: {
    background: 'none', border: 'none',
    fontSize: '12px', color: '#6b7280',
    cursor: 'pointer', fontFamily: 'inherit',
    textDecoration: 'underline', padding: 0,
  },
  input: {
    padding: '10px 14px',
    border: '1.5px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: 'inherit',
    color: '#111827',
    background: '#f9fafb',
    outline: 'none',
    transition: 'border-color 0.15s',
  },
  inputError: { borderColor: '#dc2626', background: '#fef2f2' },
  helpText: { fontSize: '12px', color: '#9ca3af', lineHeight: 1.4 },
  errorText: { fontSize: '12px', color: '#dc2626', fontWeight: '500' },
  footer: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    paddingTop: '16px', borderTop: '1px solid #f3f4f6',
    flexWrap: 'wrap', gap: '12px',
    marginTop: '4px',
  },
  footerInfo: { display: 'flex', alignItems: 'center', gap: '6px' },
  lockIcon: { fontSize: '14px' },
  footerText: { fontSize: '12px', color: '#9ca3af' },
  btnSave: {
    padding: '10px 22px', color: '#fff',
    border: 'none', borderRadius: '8px',
    fontSize: '14px', fontWeight: '600',
    cursor: 'pointer', fontFamily: 'inherit',
    whiteSpace: 'nowrap',
  },
};
